import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import DialogContent from "@material-ui/core/DialogContent";
import Input from "Components/Input/Input";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import Grid from "@material-ui/core/Grid";
import * as R from "ramda";
import Translator from "Languages/Utility/Translator";
import { editMahsooleShisheData, GetAllMahsooleShishe } from "Stores/actions";
import { read } from "Helpers/LocalStorage";
import MuiSkeleton from "Components/MuiSkeleton/MuiSkeleton";
import { DialogActions, Divider } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import showNotify from "Helpers/Notify";
import GlassService from "Services/http/endpoints/properties/GlassService";
import StatusHandler from "Helpers/StatusHandler";
import MuiColorAutoComplete from "Components/MuiColorAutoComplete/MuiColorAutoComplete";
import { ReactSVG } from "react-svg";
import MuiButton from "Components/MuiButton/MuiButton";
import infoIcon from "Assets/svg/icon/info.svg";
import { useTranslation } from "react-i18next";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import * as Icons from "react-bootstrap-icons";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";

function EditMahsooleShishe({ row }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const { mahsooleShishePagination } = useSelector((state) => ({
    mahsooleShishePagination: state.shishe.mahsooleShishePagination,
  }));
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({ nameshishe: true });
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [change, setChange] = useState(false);
  const [ListPart, setListPart] = useState(null);
  const [firstListPart, setFirstListPart] = useState(null);
  const [glassList, setGlassList] = useState([]);
  const [spacerList, setSpacerList] = useState([]);
  const [suggestedPrice, setSuggestedPrice] = useState(0);
  const [controls, setControls] = useSetState({
    nameshishe: {
      type: "text",
      value: row.Name,
      validation: {
        required: true,
      },
    },
    shisheGroup: {
      type: "select",
      selectItems: [],
      value: "",
      validation: {
        required: true,
      },
    },
    color: {
      type: "select",
      selectItems: [],
      value: "",
      validation: {
        required: true,
      },
    },
    jedare: {
      type: "select",
      selectItems: [],
      value: "",
      validation: {
        required: true,
      },
    },
    groupPrice: {
      type: "price",
      value: row.GroupPrice,
      validation: {
        required: true,
        isPrice: true,
        notZero: true,
      },
      auth: read("StypeU") === "1",
    },
    userPrice: {
      type: "price",
      value: row.UserPrice,
      validation: {
        required: true,
        isPrice: true,
        notZero: true,
      },
      auth: read("StypeU") === "2" || read("StypeU") === "5",
    },
  });

  const onFinish = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (change) {
      const { groupPrice, jedare, nameshishe, shisheGroup, userPrice, color } =
        controls;
      let updateListPart = [];
      for (let i = 0; i < ListPart.length; i++) {
        updateListPart.push({
          IdPart: ListPart[i].IdPart.Id,
          Stype: ListPart[i].Stype,
        });
      }
      if (
        !R.isEmpty(formValid) &&
        Object.values(formValid).every((item) => item === true)
      ) {
        let price = groupPrice.value;
        if (!groupPrice.auth) price = userPrice.value;
        price = +convertToEnglishNumber(price).replaceAll(",", "");
        try {
          const data = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Name: nameshishe.value,
            Id: row.Id,
            IdSwall: +jedare.value.value,
            Price: price,
            IdGroupProductGlass: +shisheGroup.value.value,
            ListPart: updateListPart,
            ColorPattern: color.value.value,
          };
          await dispatch(editMahsooleShisheData(data));
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Limit: mahsooleShishePagination.Limit,
            Page: mahsooleShishePagination.Page,
          };
          await dispatch(GetAllMahsooleShishe(params));
        } catch (err) {
          console.error("[catch error]", err);
        }
        handleDialog();
      } else if (R.isEmpty(formValid)) {
        handleDialog();
      } else {
        showNotify({
          text: t("correctFormDataRequired"),
          customClass: "error",
        });
      }
    } else {
      handleDialog();
    }
    setLoading(false);
  };

  const onClear = () => {
    setLoading(true);
    setListPart(null);
    setSuggestedPrice(0);
    setControls({ nameshishe: { value: row.Name } });
    setControls({ groupPrice: { value: row.GroupPrice } });
    setControls({ userPrice: { value: row.UserPrice } });
  };

  const onEnter = async () => {
    onClear();
    try {
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Id: row.Id,
      };
      const responseGlass = await GlassService.GetEditMahsooleShisheData(
        params
      );
      let errGlass = StatusHandler(responseGlass);
      if (!errGlass.isFail) {
        const data = responseGlass.data.Value;
        setFormData(data);
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
    setLoading(false);
  };

  const onListPartChange = (e, value) => {
    const index = +e.target.id.split("-")[0];
    const arr = [];
    arr.push(...ListPart);
    arr[index].IdPart = value;
    setListPart(arr);
    setChange(true);
  };

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
    setChange(true);
  };

  const autoCompleteHandler = async (e, value, id) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
    setFormValid((prev) => ({ ...prev, [controlName]: true }));
    setChange(true);
  };

  const autoCompleteColorHandler = async (e, value, controlName) => {
    setControls({ [controlName]: { value: value } });
    setFormValid((prev) => ({ ...prev, [controlName]: true }));
    setChange(true);
  };

  const handleDialog = () => setOpenDialog(!openDialog);

  useEffect(() => {
    if(firstListPart && glassList && spacerList && controls.jedare.value.Id) {
      try {
        const jedareMap = { 1: 1, 2: 3, 3: 5 };
        const count = jedareMap[controls.jedare.value.Id] || 1;
        const _raw_list = Array.from({ length: count }, (_, i) =>
          i % 2 === 0
            ? { IdPart: glassList[0], Stype: 1, selectItems: glassList }
            : { IdPart: spacerList[0], Stype: 2, selectItems: spacerList }
        );
        const list = firstListPart.map((item, index) => {
          const sourceList = item.Stype === 1 ? glassList : item.Stype === 2 ? spacerList : [];
          return {
            IdPart: sourceList.find(i => i.Id === item.IdPart.Id),
            Stype: item.Stype,
            selectItems: sourceList,
          };
        })
        const finalList = _raw_list.map((item, idx) => {
          if (list[idx]) {
            return {
              ...list[idx],
              selectItems: item.selectItems,
            };
          }
          return item;
        });
        setListPart(finalList);
      } catch (err) {
        console.error("[catch error]", err);
      }
    }
  }, [firstListPart, glassList, spacerList, controls.jedare]);

  useEffect(() => {
    if (formData) {
      let arr = [];
      formData.ListpartProducts.map((i) => {
        arr.push({
          IdPart: i.IdPart,
          Stype: i.Stype,
          selectItems: i.Stype === 1 ? glassList : spacerList,
        });
      });
      setListPart(arr);
    }
  }, [formData]);

  useEffect(() => {
    if (ListPart) {
      try {
        let total = 0;
        for (let i = 0; i < ListPart.length; i++) {
          total = total + ListPart[i].IdPart.Price;
        }
        setSuggestedPrice(total);
      } catch {
        handleDialog();
        showNotify({
          text: t("getDataError"),
          customClass: "error",
        });
      }
    }
  }, [ListPart]);

  useEffect(() => {
    (async () => {
      if (formData) {
        setLoading(true);
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
        };
        //! --- Get GlassGroup
        const responseGroup = await GlassService.getGroupProductGlass(params);
        let errorGroup = StatusHandler(responseGroup);
        if (!errorGroup.isFail) {
          const data = responseGroup.data.Value;
          const update = data.map((m) => {
            return {
              ...m,
              value: m.Id,
              label: m.Name,
            };
          });
          const selected = update.find((item) => item.Id === formData.IdGroup);
          setControls({ shisheGroup: { value: selected } });
          setControls({ shisheGroup: { selectItems: update } });
        }
        //! --- Get Color
        const responseColor = await GlassService.getColorMahsooleShishe(params);
        let err = StatusHandler(responseColor);
        if (!err.isFail) {
          const colorList = responseColor.data.Value;
          const items = colorList.map((m) => {
            return {
              ...m,
              value: m.Id,
              label: m.Name,
            };
          });
          const selected = items.find(
            (item) => item.Id === formData.ColorPattern.Id
          );
          setControls({ color: { value: selected } });
          setControls({ color: { selectItems: items } });
        }
        //! --- Get GlassList
        let thisGlassList = [];
        const responseGlass = await GlassService.getGlassList(params);
        let errorGlass = StatusHandler(responseGlass);
        if (!errorGlass.isFail) {
          const data = responseGlass.data.Value;
          const update = data.map((m) => {
            return {
              ...m,
              value: m.Id,
              label: m.Name,
            };
          });
          setGlassList(update);
          thisGlassList = update;
        }
        //! --- Get SpacerList
        let thisSpacerList = [];
        const responseSpacer = await GlassService.getSpacerList(params);
        let errSpacer = StatusHandler(responseSpacer);
        if (!errSpacer.isFail) {
          const data = responseSpacer.data.Value;
          const update = data.map((m) => {
            return {
              ...m,
              value: m.Id,
              label: m.Name,
            };
          });
          setSpacerList(update);
          thisSpacerList = update;
        }
        //! --- Get JedareList
        const responseWall = await GlassService.getJedareList(params);
        let errorWall = StatusHandler(responseWall);
        if (!errorWall.isFail) {
          const data = responseWall.data.Value;
          const update = data.map((m) => {
            return {
              ...m,
              value: m.Id,
              label: m.Name,
            };
          });
          const selected = update.find((item) => item.Id === formData.IdWall);
          setControls({ jedare: { value: selected } });
          setControls({ jedare: { selectItems: update } });
          //! --- Get SpacerList
          const listpartProducts = formData.ListpartProducts.map((child) => {
            if (child.Stype === 1) {
              const selected = thisGlassList.find((x) => x.Id === child.IdPart);
              return {
                ...child,
                IdPart: selected,
                selectItems: thisGlassList,
              };
            }
            if (child.Stype === 2) {
              const selected = thisSpacerList.find(
                (x) => x.Id === child.IdPart
              );
              return {
                ...child,
                IdPart: selected,
                selectItems: thisSpacerList,
              };
            }
            return null;
          });
          setFirstListPart(listpartProducts);
        }
        setLoading(false);
      }
    })();
  }, [formData]);

  const handleSuggestionPriceClick = (e) => {
    e.preventDefault();
    if (suggestedPrice && suggestedPrice !== 0) {
      setValue(
        controls.groupPrice.auth ? "groupPrice" : "userPrice",
        suggestedPrice.toString(),
        true
      );
    }
  };

  return (
    <>
      <BackDropLoading loading={loading} />
      <ActionFormatter
        title={<Translator id="virayesh" />}
        icon={<Icons.Pencil size={17} />}
        className="warning-fill"
        onClick={handleDialog}
        disabled={
          (row.IsG && read("StypeU") !== "1") ||
          read("mahsoleShisheRules")?.accessUpdate === false ||
          row.Disable
        }
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        onEnter={onEnter}
        fullWidth
        maxWidth="sm"
      >
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p>{<Translator id={"edit_glass_product"} />}</p>
          </div>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Input
                  setValue={setValue.bind(this)}
                  name={"nameshishe"}
                  validation={controls.nameshishe.validation}
                  label={<Translator id={"nameshishe"} />}
                  value={controls.nameshishe.value}
                  type="text"
                />
              </Grid>
              <Grid item xs={6}>
                <MuiAutoComplete
                  loading={loading}
                  options={controls.shisheGroup.selectItems}
                  className="mt-2"
                  label={<Translator id={"shisheGroup"} />}
                  value={controls.shisheGroup.value}
                  id={"shisheGroup"}
                  onChange={autoCompleteHandler}
                />
              </Grid>
              <Grid item xs={6}>
                <MuiColorAutoComplete
                  loading={loading}
                  options={controls.color.selectItems}
                  className="mt-2"
                  label={<Translator id={"color"} />}
                  value={controls.color.value}
                  onChange={(e, value) =>
                    autoCompleteColorHandler(e, value, "color")
                  }
                />
              </Grid>
              <Grid item xs={6}>
                <MuiAutoComplete
                  loading={loading}
                  options={controls.jedare.selectItems}
                  label={<Translator id={"jedare"} />}
                  value={controls.jedare.value}
                  id={"jedare"}
                  onChange={autoCompleteHandler}
                />
              </Grid>
              {ListPart?.map((item, i) => {
                return (
                  <Grid item sm={6} xs={12} key={"m-" + i}>
                    <MuiAutoComplete
                      autoSelect={true}
                      loading={loading}
                      options={item.selectItems}
                      label={
                        item.Stype === 1 ? (
                          <Translator id={"shishe"} />
                        ) : (
                          <Translator id={"spacer"} />
                        )
                      }
                      value={item.IdPart}
                      id={`${i}`}
                      onChange={onListPartChange}
                    />
                  </Grid>
                );
              })}
              <Grid item xs={12}>
                <Divider />
              </Grid>
              <Grid item xs={12} className="mt-4">
                {controls.groupPrice.auth === true && (
                  <Input
                    setValue={setValue.bind(this)}
                    name={"groupPrice"}
                    validation={controls.groupPrice.validation}
                    label={<Translator id={"groupPrice"} />}
                    value={controls.groupPrice.value}
                    type={controls.groupPrice.type}
                    endIcon={<Translator id="moneyUnit" />}
                  />
                )}
                {controls.userPrice.auth === true && (
                  <Input
                    setValue={setValue.bind(this)}
                    name={"userPrice"}
                    validation={controls.userPrice.validation}
                    label={<Translator id={"userPrice"} />}
                    value={controls.userPrice.value}
                    type={controls.userPrice.type}
                    endIcon={<Translator id="moneyUnit" />}
                  />
                )}
              </Grid>
              <Grid item xs={12}>
                <Alert
                  severity="info"
                  variant="outlined"
                  icon={<ReactSVG src={infoIcon} />}
                >
                  {t("suggestionPrice") + ": "}
                  <strong
                    onClick={handleSuggestionPriceClick}
                    className="handC"
                  >
                    {suggestedPrice.toLocaleString()}
                  </strong>
                </Alert>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
              color="primary"
              type="submit"
              title={<Translator id="button_save" />}
              className={"mx-1"}
              disabled={loading}
            />
            <MuiButton
              onClick={handleDialog}
              title={<Translator id="enseraf" />}
              disabled={loading}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default EditMahsooleShishe;
